import { useContext, useState } from "react";
import { DatabaseSearchContext, DateView } from "nystem-components";

const ViewListTibberConsumption = () => {
  const { search } = useContext(DatabaseSearchContext);
  const [selected, setSelected] = useState(null);

  const readings = search.data || [];
  if (!readings.length) return null;

  const daily = readings[0].resolution === "DAILY";
  const highest = Math.max(0.01, ...readings.map(({ consumption }) => consumption));
  const magnitude = 10 ** Math.floor(Math.log10(highest / 4));
  const step = [1, 2, 2.5, 5, 10].find((value) => value * magnitude >= highest / 4) * magnitude;
  const maximum = Math.ceil(highest / step) * step;
  const ticks = Array.from({ length: Math.round(maximum / step) + 1 }, (_, pos) => pos * step);
  const height = readings.length * 20;
  return (
    <section aria-label={`Tibber ${daily ? "daily" : "hourly"} electricity consumption`}>
      <div className="relative mt-4 pr-14 pl-12">
        <div className="relative h-6 text-xs leading-none text-gray-300 tabular-nums">
          {ticks.map((value) => (
            <span key={value} className="absolute -translate-x-1/2" style={{ left: `${(value / maximum) * 100}%` }}>
              {Number(value.toPrecision(12))}
            </span>
          ))}
        </div>
        <div className="relative" style={{ height }}>
          {ticks.map((value) => (
            <div
              key={value}
              className="pointer-events-none absolute top-0 bottom-0 border-l border-gray-500/60"
              style={{ left: `${(value / maximum) * 100}%` }}
            />
          ))}
          {readings.map(({ _id, consumption }, pos) => (
            <button
              key={_id}
              type="button"
              aria-label={`${consumption.toFixed(2)} kWh, ${daily ? "day" : "hour"} ${pos + 1}`}
              className={`absolute left-0 rounded-r-sm focus:outline-2 focus:outline-white ${selected === _id ? "bg-emerald-300/60" : "bg-emerald-500/45 hover:bg-emerald-300/60"}`}
              style={{ top: pos * 20 + 1, width: `${Math.max(0.5, (consumption / maximum) * 100)}%`, height: 18 }}
              onMouseEnter={() => setSelected(_id)}
              onFocus={() => setSelected(_id)}
              onClick={() => setSelected(_id)}
            />
          ))}
        </div>
        <div
          className="pointer-events-none absolute top-6 right-0 left-0 text-xs text-gray-300 tabular-nums"
          style={{ height }}
        >
          {readings.map(({ _id, _crdate, consumption }, pos) => (
            <div
              key={_id}
              className="absolute right-0 left-0 flex -translate-y-1/2 justify-between"
              style={{ top: pos * 20 + 10 }}
            >
              <DateView model={{ dateFormat: daily ? "ddd" : "time", renderAs: "span" }} value={_crdate} />
              <span className="w-12 text-right">{consumption.toFixed(2)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ViewListTibberConsumption;
